import * as Act from '@/services/legal-ad-form/components/act';
import * as Company from '@/services/legal-ad-form/components/company';
import * as HeadOffice from '@/services/legal-ad-form/components/head-office';
import * as OwnerList from '@/services/legal-ad-form/components/owner-list';
import { trimObject } from '@/shared/utils';

export default {
  id: 'gaec',
  label: 'Avis de constitution GAEC',
  shortLabel: 'Avis de constitution',
  componentsData: {
    act: { type: '' },
    company: { legalForm: 'Groupement Agricole d\'Exploitation en Commun' },
    headOffice: {},
    ownerList: []
  },
  component: () => import('@/components/legal-ads/forms/models/registration/gaec.vue'),
  validate(modelData) {
    return trimObject({
      act: Act.validate(modelData.act),
      company: Company.validate(modelData.company, {
        add: ['departmentalCommitteeAgreementDate', 'agreementNumber'],
        skip: ['legalForm', 'socialObject', 'duration', 'shareCapital', 'sharesTransferClause']
      }),
      headOffice: HeadOffice.validate(modelData.headOffice),
      ownerList: OwnerList.validate(modelData.ownerList)
    });
  },
  buildContent(modelData) {
    return [
      Act.buildContent(modelData.act, 'un Groupement Agricole d\'Exploitation en Commun'),
      Company.buildContent(modelData.company, { withoutLegalForm: true }),
      HeadOffice.buildContent(modelData.headOffice),
      OwnerList.buildContent(modelData.ownerList),
      HeadOffice.buildRegistrationContent(modelData.headOffice),
    ].flat().join("\n").replace(/undefined/g, '?');
  }
};